import { imgixHost } from 'src/config'

export const createGiftCardSale = () => {
  return {
    key: crypto.getRandomValues(new Uint32Array(1))[0],
    name: 'Gift Card',
    amount: 10,
    image: null,
    color: null,
    custom: false,
    customMinimumAmount: 10,
    customMaximumAmount: 1000
  }
}

export function giftCardSaleImageUrl (imageKey, color) {
  if (!imageKey) return null

  return `${imgixHost}/${imageKey}?fit=crop&w=600&h=400&fill=solid&fill-color=${color}&bg=${color}&fm=jpeg&auto=format`
}
